import { __spreadArray } from 'tslib';
import React, { useState, useRef } from 'react';
import cn from 'classnames';
import { Skeleton } from '@alfalab/core-components-skeleton/esm';
import { useLayoutEffect_SAFE_FOR_SSR } from '@alfalab/hooks';

var styles = {"skeletonText":"typography__skeletonText_11wc0","left":"typography__left_11wc0","center":"typography__center_11wc0","right":"typography__right_11wc0"};
require('./use-skeleton.css')

function useSkeleton(showSkeleton, skeletonProps) {
    var _a = useState(), skeletonParams = _a[0], setSkeletonParams = _a[1];
    var textRef = useRef(null);
    useLayoutEffect_SAFE_FOR_SSR(function () {
        if (showSkeleton && textRef.current) {
            var style = getComputedStyle(textRef.current);
            var textHeight = textRef.current.offsetHeight;
            var fontSize = parseInt(style.fontSize, 10);
            var lineHeight = parseInt(style.lineHeight, 10);
            var padding = (lineHeight - fontSize) % 2 === 0
                ? (lineHeight - fontSize) / 2
                : (lineHeight - fontSize - 1) / 2;
            var rows = (skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.rows)
                ? skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.rows
                : Math.ceil(textHeight / lineHeight);
            setSkeletonParams({
                height: lineHeight - padding * 2,
                padding: "".concat(padding, "px 0"),
                rows: rows,
            });
        }
        else {
            setSkeletonParams(undefined);
        }
    }, [showSkeleton, skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.rows]);
    var renderSkeleton = function (props) {
        if (showSkeleton && skeletonParams) {
            return (React.createElement("div", { className: cn(skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.wrapperClassName, props.wrapperClassName, (skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.align) && styles[skeletonProps.align]), "data-test-id": props.dataTestId }, __spreadArray([], Array(skeletonParams.rows), true).map(function (_, idx) {
                var width = Array.isArray(skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.width)
                    ? skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.width[idx]
                    : skeletonProps === null || skeletonProps === void 0 ? void 0 : skeletonProps.width;
                return (
                // eslint-disable-next-line react/no-array-index-key
                React.createElement("div", { key: idx, style: { width: width, padding: skeletonParams.padding } },
                    React.createElement(Skeleton, { visible: true, className: styles.skeletonText },
                        React.createElement("div", { style: { height: skeletonParams.height } }))));
            })));
        }
        return null;
    };
    return { renderSkeleton: renderSkeleton, textRef: textRef };
}

export { useSkeleton };
